import { append, assocPath, contains, dissoc, sort, without } from 'ramda';

import * as types from '../constants/ActionTypes';

const initialState = {};

const selectedMessages = (state = initialState, action) => {
  switch (action.type) {
    case types.SELECT_MESSAGE: {
      const { chatId, messageId, selectableType } = action.payload;
      const selectedChatMessages = state[chatId] || {};
      const messagesByType = selectedChatMessages[selectableType] || [];
      // If message is not selected, select it. If message is selected, deselect it.
      const result = contains(messageId, messagesByType)
        ? without([messageId], messagesByType)
        : sort((a, b) => a - b)(append(messageId, messagesByType));
      return assocPath([chatId, selectableType], result, state);
    }
    case types.DESELECT_MESSAGES: {
      const { chatId } = action.payload;
      return dissoc(chatId, state);
    }
    default:
      return state;
  }
};

export default selectedMessages;
